// extracted by mini-css-extract-plugin
export var gridMobileSmall = "320";
export var gridMobileSmallGap = "8";
export var gridMobileSmallGutter = "16";
export var gridMobileSmallMain = "288";
export var gridMobileSmallCol = "16.6666666667";
export var gridMobileMedium = "375";
export var gridMobileMediumGap = "8";
export var gridMobileMediumGutter = "16";
export var gridMobileMediumMain = "343";
export var gridMobileMediumCol = "21.25";
export var gridMobileLarge = "414";
export var gridMobileLargeGap = "8";
export var gridMobileLargeGutter = "16";
export var gridMobileLargeMain = "382";
export var gridMobileLargeCol = "24.5";
export var gridTablet = "768";
export var gridTabletGap = "16";
export var gridTabletGutter = "24";
export var gridTabletMain = "720";
export var gridTabletCol = "45.3333333333";
export var gridDesktop = "1024";
export var gridDesktopGap = "16";
export var gridDesktopGutter = "40";
export var gridDesktopMain = "944";
export var gridDesktopCol = "64";
export var gridDesktopHd = "1192";
export var gridDesktopHdGap = "16";
export var gridDesktopHdGutter = "40";
export var gridDesktopHdMain = "1112";
export var gridDesktopHdCol = "78";
export var gridFullGutter = "40";